import styled from 'styled-components';

const CircularButtonContainer = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 32px;
  min-height: 32px;
  border: 1px solid #00144d;
  border-radius: 50%;
  box-sizing: border-box;
  background-color: #fff !important;

  padding: 0px !important;

  font-style: normal;
  font-weight: normal;
  line-height: normal;
  font-size: 20px;
  text-align: center;
  color: #00144d;
  -webkit-transition: all 0.15s ease-in-out;
  -moz-transition: all 0.15s ease-in-out;
  -ms-transition: all 0.15s ease-in-out;
  -o-transition: all 0.15s ease-in-out;
  transition: all 0.15s ease-in-out;

  cursor: pointer;

  :focus {
    outline: none;
  }

  :hover {
    background-color: #bfc4d2 !important;
  }

  :active {
    background-color: #00144d !important;
    color: #fff;
  }
`;

export default CircularButtonContainer;



// WEBPACK FOOTER //
// ./src/components/Buttons/CircularButtonContainer.tsx